// @ts-strict-ignore
/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/feature_flags/update_tags" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdFeatureFlagsUpdateTagsCacheKeys } from "./constants";
import type { FeatureFlagsUpdateTagsResult } from "./types";

export const postEngagementAppGroupIdFeatureFlagsUpdateTags = reactQueryMutationAdapter(
  engagementAppGroupIdFeatureFlagsUpdateTagsCacheKeys,
  ({ app_group_id, desired_state, undo_identifier }): Promise<FeatureFlagsUpdateTagsResult> => {
    return fetch(`/engagement/${app_group_id}/feature_flags/update_tags`, "POST", {
      desired_state,
      undo_identifier,
    });
  }
);
